import React, { useRef } from 'react'
import SlidingPane from "react-sliding-pane";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import { getTrans as t } from "../../../Localization/translations";
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from "react-select/async";
import MaterialTable from "material-table";
import Helper from '../../../Helper';


const FilterAsset = ({state6,setState6,itemSelect,loadOptionItem,handelInputChangeItem,handelChangeItem,
    selectSerial,loadOptionsserial,handelInputChangeSerial,handelChangeserial,selectModel,loadOptionsModel,
    handelInputChangeModel,handelChangemodel,selectMake,loadOptionsMake,handelInputChangeMake,handelChangeMake,
    selectManu,loadOptionsManu,handelInputChangeManu,handelChangeManu,handleClear,handelSearch,item_master_id,
    handleTagClick,inventory_option,inventoryTableRef,fetchInventoryOptions,
}) => {
  return (
    <SlidingPane
        className="some-custom-class sidepanebar"
        // overlayClassName="custom-overlay"
        style={{ width: '60 !important' }}
        isOpen={state6.isPaneOpen}
        title="Filter By"
        onRequestClose={() => {
          setState6({ isPaneOpen: false });
        }}

      >
        <div className="col-md-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label className="col-form-label">{t("Item Number")}</label>
                <AsyncSelect
                  defaultOptions
                  isClearable
                  placeholder={t("Search for Item Number (%for All)")}
                  value={itemSelect}
                  getOptionLabel={(e) => e.itemname}
                  getOptionValue={(e) => e.itemname}
                  loadOptions={loadOptionItem}
                  onInputChange={handelInputChangeItem}
                  onChange={handelChangeItem}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label className="col-form-label">{t("Serial Number")}</label>
                <AsyncSelect
                  defaultOptions
                  isClearable
                  placeholder={t("Search for Serial number(%for All)")}
                  value={selectSerial}
                  getOptionLabel={(e) => e.serialnumber}
                  getOptionValue={(e) => e.serialnumber}
                  loadOptions={loadOptionsserial}
                  onInputChange={handelInputChangeSerial}
                  onChange={handelChangeserial}
                />
                <input type="hidden" id="contract_status" value="" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label className="col-form-label">
                  {t("Model")}
                </label>
                <AsyncSelect
                  defaultOptions
                  isClearable
                  placeholder={t("Search for Model(%for All)")}
                  value={selectModel}
                  getOptionLabel={(e) => e.model}
                  getOptionValue={(e) => e.model}
                  loadOptions={loadOptionsModel}
                  onInputChange={handelInputChangeModel}
                  onChange={handelChangemodel}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="form-group">
                <label className="col-form-label">
                  {t("Make")}
                </label>
                <AsyncSelect
                  defaultOptions
                  isClearable
                  placeholder={t("Search for Make(%for All)")}
                  value={selectMake}
                  getOptionLabel={(e) => e.make}
                  getOptionValue={(e) => e.make}
                  loadOptions={loadOptionsMake}
                  onInputChange={handelInputChangeMake}
                  onChange={handelChangeMake}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label className="col-lg-12 col-form-label">
                  {t("Manufacture")}
                </label>
                {/* <div className="col-lg-12"> */}
                <AsyncSelect
                  defaultOptions
                  isClearable
                  placeholder={t("Search for Manufacture(%for All)")}
                  value={selectManu}
                  getOptionLabel={(e) => e.manufacturer}
                  getOptionValue={(e) => e.manufacturer}
                  loadOptions={loadOptionsManu}
                  onInputChange={handelInputChangeManu}
                  onChange={handelChangeManu}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                ></AsyncSelect>
                {/* </div> */}
                <input type="hidden" id="contract_status" value="" />
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            <button
              type="button"
              className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
              onClick={handleClear}
            >
              {t("Reset")}
            </button>
            &nbsp;&nbsp;
            <button
              type="button"
              onClick={handelSearch}
              className="partyFilter add btn btn-primary ms-auto mb-0"
            >
              {t("Apply")}
            </button>
            &nbsp;&nbsp;
          </div>
          <div style={{ marginTop: '10px' }}>
            <MaterialTable
              tableRef={inventoryTableRef}
              title="Inventory List"
              columns={[
                {
                  title: "",
                  render: (rowData) => (
                    <input
                      type="checkbox"
                      checked={item_master_id === rowData.id}
                      onChange={() => handleTagClick(rowData)}
                    />
                  ),
                  sorting: false,
                },
                {
                  title: `${t("Item Number")}`,
                  field: "itemname",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Number")}</div>
                    <div>{rowData.itemname ? rowData.itemname : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Make")}`,
                  field: "make",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Make")}</div>
                    <div>{rowData.make ? rowData.make : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Model")}`,
                  field: "model",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Model")}</div>
                    <div>{rowData.model ? rowData.model : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Serial number")}`,
                  field: "serialnumber",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Serial number")}</div>
                    <div>{rowData.serialnumber ? rowData.serialnumber : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Manufacturer")}`,
                  field: "manufacturer",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Manufacturer")}</div>
                    <div>{rowData.manufacturer ? rowData.manufacturer : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Item Type")}`,
                  field: "item_type",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Item Type")}</div>
                    <div>{rowData.item_type ? rowData.item_type : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
                {
                  title: `${t("Status")}`,
                  field: "status",
                  render: rowData => <>
                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Status")}</div>
                    <div>{rowData.status ? rowData.status : "None"}</div></>,
                  headerStyle: {
                    verticalAlign: "inherit",
                    fontWeight: "bold",
                    textAlign: "left"
                  },
                  cellStyle: {
                    textAlign: "left",
                    fontSize: 12
                  }
                },
              ]}
              detailPanel={[
                {
                  render: rowData => <>
                    <div className="col-md-12" style={{ paddingLeft: "20px" }}>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Item Number')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.itemname ? rowData.itemname : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Status')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.status}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Description')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.description ? rowData.description : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Serial Number')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.serial_number ? rowData.serial_number : "None"}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Year of Manufacture')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.year ? rowData.year : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Manufacturer')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.manufacturer ? rowData.manufacturer : "None"}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Model')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.model ? rowData.model : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Make')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.make ? rowData.make : "None"}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label ">{t('Date placed in Service')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.date_place ? Helper.DateNormal(rowData.date_place) : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Life in Months')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.life_in_months ? rowData.life_in_months : "None"}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Net Book Value')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.netbookvalue ? Helper.Amount(rowData.netbookvalue) : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Original Cost')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.originalcost ? Helper.Amount(rowData.originalcost) : "None"}
                          </span>
                        </div>
                      </div>
                      <div className=" row">
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Contract Number')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.contract_number ? rowData.contract_number : "None"}
                          </span>
                        </div>
                        <div className="col-xl-3">
                          <label className="col-lg-12 col-form-label">{t('Item Type')}</label>
                        </div>
                        <div className="col-xl-3">
                          <span className="col-lg-8 view-label p">
                            {rowData.item_type ? rowData.item_type : "None"}
                          </span>
                        </div>
                      </div>
                    </div></>,
                },


              ]}
              data={fetchInventoryOptions}
              options={{
                selection: false,
                search: false,
                showSelectAllCheckbox: false,
                paging: true,
                pageSize: 5,
                pageSizeOptions: [5, 10, 25],
                emptyRowsWhenPaging: false,
                // selectionProps: (rowData) => ({
                //     checked: item_master_id === rowData.id,
                //     disabled: item_master_id !== '' && item_master_id !== rowData.id,
                //   }),
              }}

            />
          </div>
        </div>
      </SlidingPane>
  )
}

export default FilterAsset